// change images on change variants
(function () {
    if (document.querySelector('.template_product') && document.querySelector('.multicolor')) {
        const media = document.querySelectorAll('.product-gallery__media')
        const images = document.querySelectorAll('.product-gallery__media [alt]')
        const radioButtons = document.querySelectorAll('.variant-picker__option-values input')
        const activeVariant = document.querySelector('.variant-picker__option-values input:checked').value
        const pageDots = document.querySelectorAll('.page-dots .tap-area')

        const filterImages = (value) => {
            images.forEach(img => {
                const alt = img.getAttribute('alt')
                img.closest('.product-gallery__media').classList.remove('hidden')
                if (alt != value) {
                    img.closest('.product-gallery__media').classList.add('hidden')
                }
            })

            function updateLastVideoAspectRatio() {
                // Находим все элементы видео
                const videos = document.querySelectorAll('.product-gallery__media video-media');
            
                console.log(videos)
                // Удаляем класс у всех видео
                videos.forEach(video => video.classList.remove('video-aspect-ratio'));
            
                // Находим все видимые элементы и проверяем последний ли он
                const visibleVideos = Array.from(videos).filter(video => video.offsetParent !== null);
                if (visibleVideos.length > 0) {
                    const lastVisibleVideo = visibleVideos[visibleVideos.length - 1];
                    lastVisibleVideo.classList.add('video-aspect-ratio');
                }
            }
            updateLastVideoAspectRatio()
        }
        const toggleDots = () => {
            pageDots.forEach(dot => {
                dot.classList.remove('hidden')
            })
            media.forEach(element => {
                pageDots.forEach(dot => {
                    if (element.classList.contains('hidden') && element.dataset.index == dot.dataset.index) {
                        dot.classList.add('hidden')
                    }
                });
            });
        }
        radioButtons.forEach(btn => {
            btn.addEventListener('change', () => {
                const value = btn.value

                filterImages(value)
                pageDots[document.querySelector('.product-gallery__media:not(.hidden)').dataset.index].click()
                toggleDots()
            })
        });

        filterImages(activeVariant)
        pageDots[document.querySelector('.product-gallery__media:not(.hidden)').dataset.index].click()
        toggleDots()
        
    } 
})();
// change images on change variants

// change footer images
(function () {
    let arr = [1, 2];
    const footerImage_1 = document.querySelector('.footer__images_left');
    const footerImage_2 = document.querySelector('.footer__images_right');
    
    function getImageNumber(el) {
        const allImageList = el.querySelectorAll('img');
        const number = Math.floor(Math.random() * allImageList.length) + 1;
        
        el.classList.add(`footerImages_${number}`);
        const img = el.querySelector(`img:nth-child(${number})`);
        if (img) {
            img.classList.add('footer-image-active');
        }
    }
    getImageNumber(footerImage_1)
    getImageNumber(footerImage_2)
})();
// change footer images

// open klaviyo form
(function () {
    const openForm = () => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'TwE4DJ']);
    }

    const menuButton = document.querySelector('.open_claviyo')

    if (menuButton && !menuButton.querySelector('a[href]')) {
        menuButton.addEventListener('click', () => {
            openForm()
        })
    }

    
})();
// open klaviyo form

// filter blog
// (function () {
//     if (document.querySelector('.blog__tags')) {
//         const difficultyTags = [hard, medium, easy]
//         const bottomTags = document.querySelectorAll('.blog__tags_bottom .')
//     }
// })();
// filter blog

class StarsComponent extends HTMLElement {
    constructor() {
        super();
        this.initObserver();
    }

    initObserver() {
        const observer = new MutationObserver((mutationsList, observerInstance) => {
            const stampedBadge = this.querySelector('.stamped-badge');
            const stampedBadgeCount = this.querySelector('.stamped-badge .stamped-badge-caption');
            const stampedStars = this.querySelector('.stamped-starrating.stamped-badge-starrating');
            const ratingsStarsContainer = this.querySelectorAll('.ratings__star-list-wrap .ratings__stars');

            if (stampedBadge && stampedBadgeCount && stampedStars && ratingsStarsContainer.length > 0) {
                const dataRating = stampedBadge.getAttribute('data-rating');
                const dataRatingCount = stampedBadgeCount.getAttribute('data-reviews') || stampedBadge.getAttribute('data-reviews') || stampedBadgeCount.textContent;
                const ratingElement = this.querySelector('.raiting__desktop .ratings__star-size');
                const ratingElementMob = this.querySelector('.ratings__mobile .ratings__star-count');
                const ratingElementDesk = this.querySelector('.raiting__desktop .ratings__star-count');
                const reviewsCount = parseInt((dataRatingCount || '').replace(/,/g, '').match(/\d+/)?.[0] || '0', 10);
                const reviewsCountText = reviewsCount.toLocaleString();

                if (reviewsCount > 0) {
                    ratingsStarsContainer.forEach(el => {
                        el.innerHTML = stampedStars.outerHTML;
                    });
                }

                if (dataRating && reviewsCount > 0) {
                    if (ratingElement) {
                        ratingElement.textContent = dataRating;
                    }

                    if (ratingElementDesk) {
                        ratingElementDesk.hidden = reviewsCount < 10;

                        if (reviewsCount >= 10) {
                            ratingElementDesk.textContent = `(${reviewsCountText} reviews)`;
                        }
                    }

                    if (ratingElementMob) {
                        ratingElementMob.textContent =
                          reviewsCount < 10
                            ? `${dataRating} stars`
                            : `${dataRating} stars (${reviewsCountText} reviews)`;
                    }
                }

                observerInstance.disconnect();
            }
        });

        observer.observe(this, {
            childList: true,
            subtree: true
        });
    }
}

customElements.define('stars-component', StarsComponent);



/*
class ProductRatingScroll {
    constructor() {
        this.init();
    }

    init() {
        if (!document.body.classList.contains('template-product')) {
            return;
        }

        this.waitForElement(
            ['#go-stamped-main-widget', '#stamped-main-widget'],
            (stampedWidget) => {
                document.addEventListener('click', (event) => {
                    const trigger = event.target.closest(
                        '.raiting__desktop .ratings__stars, .ratings__mobile .ratings__stars, .ratings__mobile .ratings__star-size, .raiting__desktop .ratings__star-size,.raiting__desktop .ratings__star-count, .ratings__mobile .ratings__star-count'
                    );

                    if (!trigger) {
                        return;
                    }

                    stampedWidget.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                });
            }
        );
    }

    waitForElement(selectors, callback) {
        const findElement = () => {
            for (const selector of selectors) {
                const element = document.querySelector(selector);

                if (element) {
                    return element;
                }
            }

            return null;
        };

        const existingElement = findElement();

        if (existingElement) {
            callback(existingElement);
            return;
        }

        const observer = new MutationObserver(() => {
            const targetElement = findElement();

            if (targetElement) {
                observer.disconnect();
                callback(targetElement);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}


document.addEventListener('DOMContentLoaded', () => {
    new ProductRatingScroll();
});
*/

    class ProductRatingScroll {
    constructor() {
        this.init();
    }

    init() {
        if (!document.body || !document.body.classList.contains('template-product')) {
            return;
        }

        this.waitForElement(
            ['#stamped-main-widget'],
            () => {
                document.addEventListener('click', (event) => {
                    const target = event.target;

                    if (!(target instanceof Element)) {
                        return;
                    }

                    const trigger = target.closest(
                        '.raiting__desktop .ratings__stars, .ratings__mobile .ratings__stars, .ratings__mobile .ratings__star-size, .raiting__desktop .ratings__star-size,.raiting__desktop .ratings__star-count, .ratings__mobile .ratings__star-count'
                    );

                    if (!trigger) {
                        return;
                    }

                    const reviewWidget = document.querySelector('#go-stamped-main-widget');

                    if (!reviewWidget) {
                        return;
                    }

                    this.scrollToElement(reviewWidget);
                });
            }
        );
    }

    scrollToElement(element) {
        const top = element.getBoundingClientRect().top + window.pageYOffset;

        try {
            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        } catch (error) {
            window.scrollTo(0, top);
        }
    }

    waitForElement(selectors, callback) {
        const findElement = () => {
            for (const selector of selectors) {
                const element = document.querySelector(selector);

                if (element) {
                    return element;
                }
            }

            return null;
        };

        const existingElement = findElement();

        if (existingElement) {
            callback(existingElement);
            return;
        }

        if (!document.body) {
            return;
        }

        const observer = new MutationObserver(() => {
            const targetElement = findElement();

            if (targetElement) {
                observer.disconnect();
                callback(targetElement);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}

const initProductRatingScroll = () => {
    new ProductRatingScroll();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRatingScroll);
} else {
    initProductRatingScroll();
}
